import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { PermissionPageComponent } from 'src/app/modules/users/permission-page/permission-page.component';
import { ConnectedGuard } from '../shared/guards/connected-guard/connected.guard';
import { AdminGuard } from '../shared/guards/admin-guard/admin-guard.guard';

export const routes: Routes = [
  {
    path: '',
    component: PermissionPageComponent,
    canActivate: [ConnectedGuard,AdminGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class UsersRoutingModule {}

